var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCustomer = function SvgLogoBrandCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kundenlogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288,
    height: 70,
    viewBox: "0 0 288 70",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1057",
    "data-name": "Rechteck 1057",
    width: 288,
    height: 70,
    fill: "#ddd",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1880",
    "data-name": "Rechteck 1880",
    width: 288,
    height: 70.027,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1882",
    "data-name": "Rechteck 1882",
    width: 118,
    height: 70,
    transform: "translate(0 0.013)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_119",
    "data-name": "Gruppe maskieren 119",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2044",
    "data-name": "Gruppe 2044"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1879",
    "data-name": "Rechteck 1879",
    width: 66.141,
    height: 70.027,
    transform: "translate(132.187 0)",
    fill: "#096"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2041",
    "data-name": "Gruppe 2041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2040",
    "data-name": "Gruppe 2040",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10378",
    "data-name": "Pfad 10378",
    d: "M180.454,63.06V45.185h3.134v9.83l4.937-5.322H192.2l-5.059,5.786,6.049,7.581h-3.817l-5.786-7.169V63.06h-3.134M141.2,47.269h2.442S147,47.059,147,49.623c0,0,.245,2.626-2.188,3.047H141.2Zm8.99,8.3a4.985,4.985,0,0,0-2.04-2.022,5.106,5.106,0,0,0,.762-.744c1.155-1.191,1.182-3.8.394-5.147-.945-1.751-2.626-2.74-5.664-2.854l-5.5.088V63.025h3.072V55.147h3.318a4.718,4.718,0,0,1,.691.07,3.249,3.249,0,0,1,1.751,1.015,2.934,2.934,0,0,1,.35,2.863,3.039,3.039,0,0,1-2.827,1.54h-3.274l.823,2.39h2.626a5.987,5.987,0,0,0,5.164-2.259c1.156-1.251,1.173-3.8.394-5.252m25.726-.043v7.554h3.125V55.261c-.087-6.242-6.25-5.69-6.25-5.69a4.294,4.294,0,0,0-2.328.656c-.307,1.366-.525,2.626-.814,3.913l-.079.289V49.693h-3.09V63.025h3.134V55.471a3.572,3.572,0,0,1,.306-1.147,3.285,3.285,0,0,1,2.705-1.751s3.335-.3,3.317,2.889m-17.6,4.788a3.816,3.816,0,1,1,3.817-3.816,3.817,3.817,0,0,1-3.817,3.816m6.9-3.816a6.793,6.793,0,0,0-6.722-6.863h-.106a6.863,6.863,0,1,0,2.81,13.13l.876-4.053v4.377h3.142ZM172.3,35.548c-.63,2.162-2.232,4.683-4.841,5.305a12.994,12.994,0,0,1-4.315.481V37.9c1.558,0,3.379-.123,4.508-1.532a6.738,6.738,0,0,0,1.295-3.23l.079-.412a23.086,23.086,0,0,0,.464-2.626v-.437c.517-4.57,1.051-9.288,6.128-10.338a33.5,33.5,0,0,1,4.2-.228v3.5c-1.453-.07-3.291-.07-4.517,1.068a4.985,4.985,0,0,0-1.488,3.02l-.49,3.4v.087Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10379",
    "data-name": "Pfad 10379",
    d: "M159.323,31.442a4.376,4.376,0,1,1,4.6-4.376,4.482,4.482,0,0,1-4.584,4.377h-.011m0-12.333a8.174,8.174,0,0,0-8.394,7.951V41.211h3.764V29.123l1.313,5.252a8.854,8.854,0,0,0,3.318.639,8.2,8.2,0,0,0,8.386-7.975,8.184,8.184,0,0,0-8.386-7.93M183.368,37.64a4.377,4.377,0,1,1,4.605-4.377,4.491,4.491,0,0,1-4.6,4.377h0M188,19.135v12.1l-1.313-5.252a8.66,8.66,0,0,0-3.318-.648,8.194,8.194,0,0,0-8.394,7.931,8.4,8.4,0,0,0,16.789,0V19.144Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10380",
    "data-name": "Pfad 10380",
    d: "M137.939,32.194c.875-11.6,12.176-21.209,27.135-22.242a34.955,34.955,0,0,1,23.381,6.573l1.847-3.282a37.412,37.412,0,0,0-24.746-5.874C149.7,9.006,138.027,19.747,137.764,32.194c0,0,.07.228.175,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10381",
    "data-name": "Pfad 10381",
    d: "M214.863,49.7h2.1l3.195,11.44L223,49.7h2.722l2.889,11.44L231.81,49.7h2.031L229.8,63.024h-2.468l-2.906-11.642-2.959,11.642H218.9ZM242.4,62.657a7.573,7.573,0,0,1-3.081.63c-3.5,0-5.05-2.109-5.05-5.252,0-2.889,1.811-4.937,4.569-4.937,3.256,0,4.306,2.372,4.306,5.515h-7a3.2,3.2,0,0,0,3.133,3.256h.088a5.759,5.759,0,0,0,3-.98Zm-1.173-5.419a2.45,2.45,0,0,0-2.174-2.7,2.327,2.327,0,0,0-.25-.014,2.715,2.715,0,0,0-2.626,2.713Zm3.6,3.9a4.862,4.862,0,0,0,2.241.692c.823,0,1.838-.35,1.838-1.4,0-1.75-4.228-1.628-4.228-4.376,0-2.031,1.515-3.011,3.44-3.011a7.526,7.526,0,0,1,2.241.385L250.209,55a5.349,5.349,0,0,0-1.9-.491c-.875,0-1.751.377-1.751,1.182,0,1.987,4.237,1.418,4.237,4.534,0,2.084-1.672,3.047-3.414,3.047a5.565,5.565,0,0,1-2.678-.543Zm13.358-6.389H255.61v5.339a1.55,1.55,0,0,0,1.515,1.751,2.213,2.213,0,0,0,1.225-.35v1.531a5.7,5.7,0,0,1-1.532.272c-1.855,0-3-.876-3-2.836V54.753H251.61V53.3h2.206V51.041l1.794-.578V53.3h2.583Zm15.056,7.9a7.512,7.512,0,0,1-3.082.63c-3.5,0-5.05-2.109-5.05-5.252,0-2.889,1.82-4.937,4.578-4.937,3.247,0,4.306,2.372,4.306,5.515h-7a3.193,3.193,0,0,0,3.133,3.255h.079a5.7,5.7,0,0,0,3-.98Zm-1.165-5.419a2.458,2.458,0,0,0-2.192-2.7c-.08-.008-.161-.013-.241-.013a2.715,2.715,0,0,0-2.626,2.713Zm14.636-5.164a6.13,6.13,0,0,0-3.668-.919,5.252,5.252,0,0,0-.1,10.443,7.686,7.686,0,0,0,2.136-.228V57.317h-2.81V55.742H287v6.95a12.272,12.272,0,0,1-4.079.595c-4.228,0-7-2.722-7-7s2.985-6.854,7.064-6.854a10.028,10.028,0,0,1,3.922.674Z",
    fill: "#096"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2043",
    "data-name": "Gruppe 2043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2042",
    "data-name": "Gruppe 2042",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10382",
    "data-name": "Pfad 10382",
    d: "M51.793,38.83a2.2,2.2,0,0,0-3.107,0L46.615,40.9a2.2,2.2,0,0,0,2.944,3.27,2.089,2.089,0,0,0,.163-.163l2.071-2.071A2.2,2.2,0,0,0,51.793,38.83Z",
    fill: "none",
    stroke: "#008c57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.156
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10383",
    "data-name": "Pfad 10383",
    d: "M54.9,41.937a2.2,2.2,0,0,0-3.107,0l-2.073,2.071a2.2,2.2,0,0,0,3.107,3.107L54.9,45.044A2.2,2.2,0,0,0,54.9,41.937Z",
    fill: "none",
    stroke: "#008c57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.156
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10384",
    "data-name": "Pfad 10384",
    d: "M58,45.044a2.2,2.2,0,0,0-3.107,0l-2.071,2.071a2.2,2.2,0,0,0,3.107,3.107L58,48.151A2.2,2.2,0,0,0,58,45.044Z",
    fill: "none",
    stroke: "#008c57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.156
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10385",
    "data-name": "Pfad 10385",
    d: "M61.111,48.151h0a2.2,2.2,0,0,0-3.107,0l-2.071,2.071a2.2,2.2,0,0,0,3.107,3.107l2.071-2.071A2.2,2.2,0,0,0,61.111,48.151Z",
    fill: "none",
    stroke: "#008c57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.156
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10386",
    "data-name": "Pfad 10386",
    d: "M70.646,29.3a8.788,8.788,0,0,0-12.425,0l-3.108,3.108a2.2,2.2,0,0,0,3.107,3.107l3.112-3.107,9.318,9.318A8.787,8.787,0,0,0,70.646,29.3Z",
    fill: "none",
    stroke: "#008c57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.156
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10387",
    "data-name": "Pfad 10387",
    d: "M61.324,32.4l8.5,8.5a2.192,2.192,0,1,1-3.1,3.1l-5.909-5.909-.009.009,5.909,5.909a2.19,2.19,0,0,1-3.1,3.1l-5.9-5.9-.009.009,5.909,5.909a2.192,2.192,0,0,1,0,3.1,2.17,2.17,0,0,1-1.547.638,2.261,2.261,0,0,1-.595-.089.019.019,0,0,1-.006.012,2.148,2.148,0,0,0,2.158-.552,2.2,2.2,0,0,0,.117-2.99,2.2,2.2,0,0,0,3.107-3.107A2.2,2.2,0,0,0,69.9,40.975Z",
    fill: "none",
    stroke: "#008c57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.156
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10388",
    "data-name": "Pfad 10388",
    d: "M58.227,29.289A8.792,8.792,0,0,0,45.795,41.723l.009-.009A8.78,8.78,0,0,1,58.218,29.3Z",
    fill: "none",
    stroke: "#008c57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.156
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10389",
    "data-name": "Pfad 10389",
    d: "M1.114,66.2H1.73a1.8,1.8,0,0,0,1.839,1.76,1.963,1.963,0,0,0,.217-.018c.968,0,1.686-.487,1.686-1.381,0-.931-.616-1.153-2.028-1.436-1.218-.24-2.075-.607-2.075-1.76,0-1.051.885-1.742,2.2-1.742a2.07,2.07,0,0,1,2.311,1.8c.005.044.009.087.012.131h-.6a1.551,1.551,0,0,0-1.676-1.413l-.038,0c-1,0-1.612.478-1.612,1.208,0,.783.607,1.023,1.788,1.245,1.279.25,2.34.561,2.34,1.945,0,1.171-.94,1.927-2.321,1.927a2.366,2.366,0,0,1-2.642-2.053c-.009-.07-.015-.141-.017-.212",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10390",
    "data-name": "Pfad 10390",
    d: "M7.256,67.52V64.046H6.533v-.468h.723V62.114h.57v1.464h.885v.469H7.826v3.381c0,.342.157.45.459.45a1.092,1.092,0,0,0,.379-.074h.028v.487a1.533,1.533,0,0,1-.524.083c-.55,0-.912-.244-.912-.854",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10391",
    "data-name": "Pfad 10391",
    d: "M9.471,61.752h.57v.811h-.57Zm0,1.825h.57v4.762h-.57Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10392",
    "data-name": "Pfad 10392",
    d: "M11.37,64.046h-.69v-.469h.69v-.848c0-.709.388-1.023,1.116-1.023.065,0,.287.009.324.009v.492h-.25c-.478,0-.626.185-.626.543v.829h.885v.469h-.885v4.289h-.561V64.046Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10393",
    "data-name": "Pfad 10393",
    d: "M13.8,67.52V64.046h-.718v-.468H13.8V62.114h.57v1.464h.885v.469h-.885v3.381c0,.342.157.45.459.45A1.092,1.092,0,0,0,15.2,67.8h.028v.487a1.533,1.533,0,0,1-.524.083c-.545,0-.912-.244-.912-.854",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10394",
    "data-name": "Pfad 10394",
    d: "M15.959,66.94V63.573h.57V66.9a.993.993,0,0,0,.9,1.076,1.049,1.049,0,0,0,.224-.006,1.354,1.354,0,0,0,1.382-1.325c0-.031,0-.062,0-.093V63.573H19.6v4.762h-.561v-.7H19.02a1.7,1.7,0,0,1-1.492.811,1.438,1.438,0,0,1-1.565-1.3,1.456,1.456,0,0,1,0-.209",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10395",
    "data-name": "Pfad 10395",
    d: "M20.554,63.58h.57v.727h.018a1.837,1.837,0,0,1,1.6-.827,1.4,1.4,0,0,1,1.517,1.272,1.352,1.352,0,0,1,0,.211v3.381h-.57V65.013A.96.96,0,0,0,22.6,63.962a1.4,1.4,0,0,0-1.472,1.324v3.05h-.576Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10396",
    "data-name": "Pfad 10396",
    d: "M25.142,68.765h.552c.1.552.644.774,1.335.774,1.014,0,1.492-.524,1.492-1.362v-.755h-.028a1.656,1.656,0,0,1-1.51.829,2.414,2.414,0,0,1,0-4.772,1.635,1.635,0,0,1,1.51.838h.028V63.58h.561v4.581a1.849,1.849,0,0,1-.444,1.282,2.085,2.085,0,0,1-1.594.57c-1.168-.006-1.822-.539-1.9-1.248m3.418-2.9c0-1.125-.5-1.908-1.538-1.908-.94,0-1.492.764-1.492,1.927,0,1.088.478,1.89,1.483,1.89,1.058-.005,1.545-.769,1.545-1.913Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10397",
    "data-name": "Pfad 10397",
    d: "M31.175,65.972c0-1.584.9-2.5,2.038-2.5a1.7,1.7,0,0,1,1.566.894H34.8V61.752h.57v6.587H34.8V67.63h-.018a1.706,1.706,0,0,1-1.547.838c-1.283,0-2.056-1.032-2.056-2.5m3.668.009c0-1.171-.561-2.028-1.594-2.028-.94,0-1.483.838-1.483,2.028,0,1.116.478,2.01,1.483,2.01,1.042,0,1.594-.82,1.594-2.01",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10398",
    "data-name": "Pfad 10398",
    d: "M36.078,65.963a2.251,2.251,0,0,1,1.987-2.487c.062-.007.124-.011.186-.013,1.529,0,2.056,1.261,2.047,2.6H36.667c.028,1.07.543,1.908,1.631,1.908a1.326,1.326,0,0,0,1.39-1.07h.552a1.86,1.86,0,0,1-1.945,1.557,2.221,2.221,0,0,1-2.217-2.5m3.622-.351c-.028-.94-.469-1.677-1.446-1.677s-1.473.727-1.575,1.677Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10399",
    "data-name": "Pfad 10399",
    d: "M41.007,63.576h.57v.885h.016a1.616,1.616,0,0,1,1.455-.922.592.592,0,0,1,.157.019v.561a1.382,1.382,0,0,0-1.014.231,1.557,1.557,0,0,0-.616,1.282v2.709h-.57Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10400",
    "data-name": "Pfad 10400",
    d: "M45.341,61.752H47.93a1.991,1.991,0,0,1,1.547.57,1.769,1.769,0,0,1,.459,1.27c0,1.218-.709,1.88-2.093,1.88h-1.89v2.867h-.616V61.752Zm2.46,3.2c1.07,0,1.51-.506,1.51-1.335,0-.848-.506-1.316-1.455-1.316h-1.9v2.654H47.8Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10401",
    "data-name": "Pfad 10401",
    d: "M50.363,66.2h.616a1.8,1.8,0,0,0,1.839,1.76,1.963,1.963,0,0,0,.217-.018c.968,0,1.686-.487,1.686-1.381,0-.931-.616-1.153-2.028-1.436-1.218-.24-2.075-.607-2.075-1.76,0-1.051.885-1.742,2.2-1.742a2.069,2.069,0,0,1,2.309,1.8c.005.043.009.087.012.13h-.6a1.551,1.551,0,0,0-1.676-1.413l-.038,0c-1,0-1.612.478-1.612,1.208,0,.783.607,1.023,1.788,1.245,1.279.25,2.34.561,2.34,1.945,0,1.171-.94,1.927-2.321,1.927a2.365,2.365,0,0,1-2.64-2.055c-.009-.07-.015-.141-.017-.211",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10402",
    "data-name": "Pfad 10402",
    d: "M56.26,61.752H58.6c1.945,0,2.82,1.362,2.82,3.317s-.94,3.271-2.885,3.271H56.26ZM58.519,67.8c1.575,0,2.256-1.06,2.256-2.728s-.616-2.774-2.192-2.774h-1.7v5.5Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10403",
    "data-name": "Pfad 10403",
    d: "M63.725,61.752h2.737a1.984,1.984,0,0,1,1.4.478,1.543,1.543,0,0,1,.478,1.181,1.366,1.366,0,0,1-1,1.427v.028a1.607,1.607,0,0,1,1.282,1.621,1.783,1.783,0,0,1-.478,1.288,2.114,2.114,0,0,1-1.557.561H63.725Zm2.728,2.894a1.135,1.135,0,0,0,1.258-1,1.038,1.038,0,0,0,.006-.193,1.1,1.1,0,0,0-1.027-1.169,1.081,1.081,0,0,0-.22.008H64.34v2.348h2.111Zm.092,3.132a1.564,1.564,0,0,0,1.116-.379,1.233,1.233,0,0,0,.333-.9,1.282,1.282,0,0,0-1.446-1.316h-2.2v2.6Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10404",
    "data-name": "Pfad 10404",
    d: "M69.087,67.125c0-1.134.885-1.362,1.964-1.492.94-.111,1.282-.166,1.282-.644V64.9c0-.644-.407-.959-1.144-.959-.848,0-1.288.351-1.335,1.06h-.561c.065-.922.672-1.52,1.9-1.52,1.042,0,1.686.435,1.686,1.473V67.54c0,.287.111.407.314.413a1.034,1.034,0,0,0,.213-.037h.028v.413a.922.922,0,0,1-.388.074.636.636,0,0,1-.7-.567.737.737,0,0,1,0-.1v-.1h-.028a1.915,1.915,0,0,1-1.668.82c-.89,0-1.563-.441-1.563-1.326m3.252-.509V65.76a3.947,3.947,0,0,1-1.236.314c-.8.111-1.418.231-1.418,1.051,0,.663.5.866,1.06.866a1.462,1.462,0,0,0,1.591-1.32c0-.018,0-.036,0-.054Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10405",
    "data-name": "Pfad 10405",
    d: "M73.956,63.58h.57v.727h.014a1.836,1.836,0,0,1,1.6-.827,1.4,1.4,0,0,1,1.517,1.272,1.351,1.351,0,0,1,0,.211v3.381h-.57V65.013A.96.96,0,0,0,76,63.962a1.4,1.4,0,0,0-1.472,1.324v3.05h-.57Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10406",
    "data-name": "Pfad 10406",
    d: "M78.582,61.752h.57V65.87l2.367-2.293h.727L80.423,65.3l2.047,3.039h-.661L80.03,65.669l-.875.838v1.834h-.57Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10407",
    "data-name": "Pfad 10407",
    d: "M83.98,61.753h.635l1.144,4.442c.129.487.305,1.3.305,1.3h.018s.185-.792.314-1.264L87.6,61.752h.663l1.208,4.47c.12.469.305,1.27.305,1.27H89.8s.185-.811.305-1.3l1.153-4.442h.616l-1.788,6.587h-.626l-1.255-4.8c-.12-.416-.259-1.07-.259-1.07h-.018s-.139.644-.25,1.07l-1.292,4.8h-.65Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10408",
    "data-name": "Pfad 10408",
    d: "M91.751,65.963a2.251,2.251,0,0,1,1.987-2.487c.062-.007.124-.011.186-.013,1.529,0,2.056,1.261,2.047,2.6H92.34c.028,1.07.543,1.908,1.631,1.908a1.326,1.326,0,0,0,1.39-1.07h.552a1.86,1.86,0,0,1-1.945,1.557,2.221,2.221,0,0,1-2.217-2.5m3.622-.351c-.028-.94-.469-1.677-1.446-1.677s-1.473.727-1.575,1.677Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10409",
    "data-name": "Pfad 10409",
    d: "M96.378,66.857h.58a1.218,1.218,0,0,0,1.3,1.136c.035,0,.07-.006.1-.011.792,0,1.208-.37,1.208-.922,0-.524-.3-.7-1.27-.922s-1.742-.45-1.742-1.372c0-.792.681-1.292,1.658-1.292A1.553,1.553,0,0,1,99.97,64.79c0,.031.008.062.011.093h-.57c-.065-.617-.487-.94-1.2-.94-.737,0-1.088.351-1.088.792,0,.543.45.672,1.362.885.959.2,1.649.441,1.649,1.427,0,.848-.681,1.418-1.788,1.418a1.72,1.72,0,0,1-1.952-1.451c-.008-.052-.013-.1-.016-.157",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10410",
    "data-name": "Pfad 10410",
    d: "M101.093,67.52V64.046h-.718v-.468h.718V62.114h.57v1.464h.889v.469h-.885v3.381c0,.342.157.45.459.45a1.092,1.092,0,0,0,.379-.074h.028v.487a1.533,1.533,0,0,1-.524.083c-.546,0-.916-.244-.916-.854",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10411",
    "data-name": "Pfad 10411",
    d: "M104.433,65.963a2.251,2.251,0,0,1,1.987-2.487c.062-.007.124-.011.186-.013,1.529,0,2.056,1.261,2.047,2.6h-3.631c.028,1.07.543,1.908,1.631,1.908a1.326,1.326,0,0,0,1.39-1.07h.552a1.861,1.861,0,0,1-1.945,1.557,2.221,2.221,0,0,1-2.217-2.5m3.619-.351c-.028-.94-.469-1.677-1.446-1.677s-1.473.727-1.575,1.677Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10412",
    "data-name": "Pfad 10412",
    d: "M109.213,65.051c0-1.945,1.116-3.428,3.113-3.428a2.416,2.416,0,0,1,2.6,2.038h-.635a1.841,1.841,0,0,0-1.964-1.5c-1.7,0-2.469,1.3-2.469,2.894,0,1.621.82,2.876,2.386,2.876a2.038,2.038,0,0,0,2.173-2.192v-.231H112.3v-.543h2.725v3.381h-.432l-.129-1.051h-.028a2.472,2.472,0,0,1-2.2,1.181c-1.922-.006-3.019-1.452-3.019-3.425",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10413",
    "data-name": "Pfad 10413",
    d: "M2,.014H4.58L9.268,14.187c.293.879.746,2.558.746,2.558h.052s.453-1.7.746-2.558L15.448.014h2.5l-6.68,19.047H8.629Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10414",
    "data-name": "Pfad 10414",
    d: "M20.007.014H33.462V2.12H22.4V8.14H32.448v2.025H22.4v6.686H33.78v2.21H20.007Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10415",
    "data-name": "Pfad 10415",
    d: "M36.575.014h8.9c3.357,0,5.622,2.1,5.622,5.222a4.5,4.5,0,0,1-3.3,4.716v.08c1.945.694,2.558,2.025,2.743,4.849.213,3.064.533,3.838.879,4.075v.108H48.831c-.4-.345-.481-1.067-.694-4.263-.185-2.8-1.3-3.782-3.862-3.782h-5.3v8.045h-2.4Zm2.4,9.056H44.62c2.663,0,4-1.332,4-3.489,0-2.318-1.067-3.489-3.862-3.489h-5.78Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10416",
    "data-name": "Pfad 10416",
    d: "M54,.014H67.456V2.12H56.4V8.14H66.442v2.025H56.4v6.686H67.773v2.21H54Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1881",
    "data-name": "Rechteck 1881",
    width: 2.4,
    height: 19.047,
    transform: "translate(70.624 0.013)",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10417",
    "data-name": "Pfad 10417",
    d: "M76.648.014h2.531l8.679,13.239c.638.986,1.384,2.451,1.384,2.451h.052V.014h2.238V19.061h-2.45L80.343,5.794c-.613-.931-1.412-2.37-1.412-2.37h-.052V19.061H76.641V.014Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10418",
    "data-name": "Pfad 10418",
    d: "M93.909.014h15.079V2.12h-6.341V19.064h-2.4V2.114H93.906V.014Z",
    fill: "#008c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10419",
    "data-name": "Pfad 10419",
    d: "M111.412,16.425H114v2.639h-2.583Zm.1-10.311V.014h2.37v6.1l-.586,8.338h-1.2Z",
    fill: "#008c57"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-customer.2190260892bbcd70e0abc8df9bcc65d9.svg";